<template>
	<div id="retrospect" style="margin-top: 67px;">
		<div class="focuImg" ref="element">
			<div id="bannerimg" class="swiper-container bjh bannerimg">
				<img style="width: 100%;" src="/static/img/top_banner.png" alt="重要产品追溯" />
			</div>
		</div>
		<div v-if="navBarFixed == true" style="height: 68px;"></div>
		<ul class="TopNav" :class="navBarFixed == true ? 'navBarWrap' :''">
			<li :class="TopNav==1?'active':''" @click="goAnchor('#a')">
				功能亮点
			</li>
			<li :class="TopNav==2?'active':''" @click="goAnchor('#b')">
				解决方案
			</li>
			<li :class="TopNav==3?'active':''" @click="goAnchor('#c')">
				运用行业
			</li>
			<li :class="TopNav==4?'active':''" @click="goAnchor('#d')">
				定制方案
			</li>
			<li :class="TopNav==5?'active':''" @click="goAnchor('#e')">
				社会意义
			</li>
			<li :class="TopNav==6?'active':''" @click="goAnchor('#f')">
				联系我们
			</li>
		</ul>
		<a class="content2 content1 flexY" ref="a">
			<div class="mddw" id="a"></div>
			<div style="margin-top: 80px;">
				<div class="gnld">
					<p class="biaoti" style="margin-bottom: 100px;">功能亮点</p>
					<ul class="iocBox">
						<li v-for="(item,index) in iocBox" :key="'iocBox'+index">
							<img :src="item.src" alt="智慧农贸" />
							<p v-text="item.name"></p>
						</li>
					</ul>
				</div>
			</div>

		</a>
		<a class="content2 flexY content1 bjh zuhe" ref="b">
			<div class="mddw" id="b"></div>
			<div class="" style="margin-top: 85px;">
				<p class="biaoti">解决方案</p>
				<ul class="faUl">
					<li class="faList" style="height: 570px;padding-left: 182px;">
						<div>
							<img src="../../static/img/qklfw_img_illtration.png" alt="重要产品追溯" />
						</div>
						<div style="margin-left: 70px;width: 320px;" class="textBox">
							<p class="name">区块链防伪</p>
							<p class="text">利用区块链防篡改的属性，实现一物一码全流程正品追溯。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_hardtocopy.png" alt="重要产品追溯" />
									<p>难仿制</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_easytoidentify.png" alt="重要产品追溯" />
									<p>易识别</p>
								</div>
								<div><img src="../../static/img/icon_customization.png" alt="重要产品追溯" />
									<p>定制化</p>
								</div>
							</div>
						</div>
					</li>
					<li class="faList" style="padding-left: 223px;">
						<div style="width: 400px;">
							<p class="name">数字化溯源平台</p>
							<p class="text">生产、库存、物流、经销商、门店等供应链系统数据可公开化，提高效率，提升上下游信用体系建设。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_wholeprocesstracing.png" alt="重要产品追溯" />
									<p>全程追溯</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_statisticalanalysis.png" alt="重要产品追溯" />
									<p>统计分析</p>
								</div>
								<div><img src="../../static/img/icon_customization.png" alt="重要产品追溯" />
									<p>定制化</p>
								</div>
							</div>
						</div>
						<div style="margin-left:135px;">
							<img src="../../static/img/img_syptfw.png" alt="重要产品追溯" />
						</div>
					</li>
					<li class="faList" style="padding-left: 204px;">
						<div>
							<img src="../../static/img/dsjyx_img_illtration.png" alt="重要产品追溯" />
						</div>
						<div style="margin-left: 58px;width: 376px;" class="textBox">
							<p class="name">大数据营销分析智能化</p>
							<p class="text">一物一码产品身份管理，流转环节全程数据管控，大数据智能化分析，清晰化生产库存管理及营销效果监控</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_intelligence.png" alt="重要产品追溯" />
									<p>智能</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_dataanalysis.png" alt="重要产品追溯" />
									<p>数据分析</p>
								</div>
								<div><img src="../../static/img/icon_visualization.png" alt="重要产品追溯" />
									<p>可视化</p>
								</div>
							</div>
						</div>
					</li>
					<li class="faList" style="padding-left: 180px;">
						<div style="width: 381px;">
							<p class="name">溯源系统，从基地到餐桌全程追踪</p>
							<p class="text">扫码即可溯源,为每一份农产品制作独一无二的溯源档案。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/szhsy_icon_qczs.png" alt="重要产品追溯" />
									<p>智慧追溯</p>
								</div>
								<div><img src="../../static/img/syxt_icon_aq.png" alt="重要产品追溯" />
									<p>数字营销</p>
								</div>

							</div>
						</div>
						<div style="margin-left: 138px;">
							<img src="../../static/img/syxt_img_illtration.png" alt="重要产品追溯" />
						</div>
					</li>
					<li class="faList" style="padding-left: 180px;margin-bottom: 105px;">
						<div>
							<img src="../../static/img/qczs_img_illtration.png" alt="重要产品追溯" />
						</div>
						<div style="margin-left: 85px;width: 375px;" class="textBox">
							<p class="name">全程追溯、追溯到人</p>
							<p class="text">记从生产到流通全程追溯，落实到人，录生产工序流通行为，监控流程节点的每个行为</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/syxt_icon_zhzs.png" alt="重要产品追溯" />
									<p>智慧追溯</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_fullfunction.png" alt="重要产品追溯" />
									<p>安全</p>
								</div>
								<div><img src="../../static/img/qczs_icon_ss.png" alt="重要产品追溯" />
									<p>实时</p>
								</div>
							</div>
						</div>
					</li>

				</ul>
			</div>
		</a>
		<a class="content2 content1 yyhy" style="" ref="c">
			<div class="mddw" id="c"></div>
			<div>
				<p class="biaoti" style="margin-bottom: 18px;">运用行业</p>
				<p class="biaoti1">原产地保真 二维码数据 全程溯源</p>
				<div class="row">
					<div class="yyhyitem">
						<img src="../../static/img/yyhy_icon_ncp.png" />
						<p class="t">农产品</p>
						<p class="con">
							从种子、环境、生产过程到储运销售，全流程管控，全程透明化展现
						</p>
					</div>
					<div class="yyhyitem" >
						<img src="../../static/img/yyhy_icon_rl.png" style="padding-top: 80px;" />
						<p class="t">肉类</p>
						<p class="con">
							从养殖、宰杀、封装、过程到储运销售，全流程管控，全程透明化展现
						</p>
					</div>
					<div class="yyhyitem" style="margin-right: 0px;">
						<img src="../../static/img/yyhy_icon_scp.png" />
						<p class="t">水产品</p>
						<p class="con">
							从捕捞到冷冻运输、销售，全流程管控，全程透明化展现
						</p>
					</div>
				</div>
				<div class="row" style="width: 732px;margin-top: -50px;">
					<div class="yyhyitem">
						<img src="../../static/img/yyhy_icon_zyc.png" style="padding-top: 72px;"/>
						<p class="t">中药材</p>
						<p class="con">
							从种植、环境、采摘/挖、储运销售，全流程管控，全程透明化展现
						</p>
					</div>
					<div class="yyhyitem" style="margin-right: 0px;">
						<img src="../../static/img/yyhy_icon_ylqx.png" />
						<p class="t">医疗器械</p>
						<p class="con">
							从生产、封装过程到储运销售，全流程管控，全程透明化展现
						</p>
					</div>

				</div>
				<div></div>
			</div>

		</a>
		<a class="content1 dzfa" ref="d" style="">
			<div class="mddw" id="d"></div>
			<div style="padding-top:104px">
				<p class="biaoti" style="margin-bottom: 0;color: #fff;">重要产品追溯系统，可定制解决用户不同需求</p>
				<p class="fbiaoti" style="color: #fff;font-size: 18px;margin-top: 35px;margin-bottom: 108px;">攻克上千种防伪难题</p>
				<div class="cpdz" >
					<div  class="cpdzitem" v-for="(item,index) in list" :key="index">
						<img :src="item.src" alt="" />
						<p class="t">{{item.name}}</p>
						<p class="con">{{item.con}}</p>
					</div>

				</div>
			</div>
		</a>
		<a class="content2  content1 shyy" style="" ref="e">
			<div class="mddw" id="e"></div>
			<div style="margin-top: 120px;">
				<p class="biaoti" style="margin-bottom: 82px;">平台社会意义</p>
				<div id="shyyflex">
					<div class="shyyitem">
						<img src="../../static/img/shyy_img_nqhy.png"/>
						<div class="t">农企获益</div>
						<div class="con">提升企业的品牌形象和价值
全链条把控风险，确保安全
提升食品安全应对能力，追根溯源
树立行业标杆，打造核心竞争力</div>

					</div>
					<div class="shyyitem">
						<img src="../../static/img/shyy_img_xfz.png"/>
						<div class="t">消费者</div>
						<div class="con">可全面了解、查询食品信息，提高
信息透明度
利于消费者自我保护，打消
安全顾虑，安心消费
利于消费者维权及反馈</div>

					</div>
					<div class="shyyitem">
						<img src="../../static/img/shyy_img_shjz.png"/>
						<div class="t">社会价值</div>
						<div class="con">提高食品质量安全监管水平
提高对问题食品的发现和处理能力
防止重大安全事件的发生与蔓延
促进食品流通和出口贸易</div>

					</div>

				</div>
			</div>
		</a>

		<div style="height: 196px;line-height: 196px;font-size: 24px;font-weight: 400;color: #FEFEFE;background:url('../../static/img/img_bg_contactus.png') 0/100% 100%;text-align: center;">
			现在联系我们，即可为您定制重要产品追溯方案！
		</div>
		<div class="footerbox" ref="f">
			<div class="mddw" id="f"></div>
			<div class="footerboxTop">
				<div class="list1">
					<p class="p1">联系我们</p>
					<div class="xian"></div>
					<p class="p2">服务热线</p>
					<p class="p3">0571-87357305</p>
					<p class="p2">公司邮箱</p>
					<p class="p3">zjax@ansuw.com</p>
				</div>
				<div class="list2">
					<p class="p1">产品服务</p>
					<div class="xian"></div>
					<p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
						<a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
						<a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
						<a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
						<a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
						<a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
						<a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
						<a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
						<a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
						<a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
						<a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
					</div>
					<p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a>智慧农贸追溯电子秤</a>
						<a>商户信用公示屏</a>
						<a>放心农贸触摸一体机</a>
						<a>数据大屏</a>
					</div>
				</div>
				<div class="list3">
					<p class="p1">关于我们</p>
					<div class="xian"></div>
					<p class="p2">
						<a href="http://www.ax168.com/about/#a">企业简介</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#b">企业优势</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#c">资质荣誉</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#d">企业特色</a>
					</p>
				</div>
			</div>
			<div class="footerboxC">
				<div class="xian"></div>
				<div class="textList">
					<p>解决方案</p>
					<p>
						<a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
					</p>
				</div>
				<div class="xian"></div>
			</div>
			<div class="footerboxb">
				<p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
        <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
				<p>公安部备案号：33010602001517</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				navBarFixed: false,
				gengduo: false,
				TopNav: 1,
					list: [{
					name: '全流程追溯监管',
					con:"产品全过程“身份管理”、品质把控、产品保障",
					src: '/static/img/zycpzs_icon_zsjg.png'
				}, {
					name: '个性化营销',
					con:"深度定制二维码营销系统链接企业与门店卖场、消费者之间的关系，提高对消费者的粘性维护",
					src: '/static/img/zycpzs_icon_gxhyx.png'
				}, {
					name: '大数据分析',
					con:"扫码带来海量活动数据，通过分析产生有价值的消费者洞察，提升个性化用户体验，树立品牌价值",
					src: '/static/img/zycpzs_icon_dsjfx.png'
				}, {
					name: '品牌建设',
					con:"建立溯源体系可以提升品牌形象，提升产品防伪等级和产品附加值，建设高质可信的品牌形象",
					src: '/static/img/zycpzs_icon_ppjs.png'
				},{
					name: '满足国家政策',
					con:"打造：前端开发、中间可控、后续抽检“产品信息管控、质量安全监管模式",
					src: '/static/img/zycpzs_icon_gjzc.png'
				} ],
				iocBox: [{
					name: '权威数据',
					src: '/static/img/gnld_icon_qwsj.png'
				}, {
					name: '产品追溯',
					src: '/static/img/gnld_icon_cpzs.png'
				}, {
					name: '大数据分析',
					src: '/static/img/gnld_icon_shjfx.png'
				}, {
					name: '绿色制造',
					src: '/static/img/gnld_icon_lszz.png'
				}, {
					name: '防窜货管理',
					src: '/static/img/gnld_icon_fchgl.png'
				}, {
					name: '积分商城',
					src: '/static/img/gnld_icon_jfsc.png'
				}, {
					name: '视频直播',
					src: '/static/img/gnld_icon_spzb.png'
				}, {
					name: '监督检查',
					src: '/static/img/gnld_icon_jdjc.png'
				}, {
					name: '疫情监测',
					src: '/static/img/gnld_icon_yqjc.png'
				}, {
					name: '灵活定制',
					src: '/static/img/gnld_icon_lhdz.png'
				}],
         ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },


			}
		},
		created: function() {
        let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
			this.$emit('footer', false);
			this.$emit('footer1', false);
			this.$emit('footer2', true);

		},
		activated() {
//			document.title = "安宣智慧农贸-智慧农贸方案-安宣农贸解决方案"
			document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
		},
		methods: {
      handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
			goAnchor(selector) {
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			watchScroll() {
								var scrollTop =
									window.pageYOffset ||
									document.documentElement.scrollTop ||
									document.body.scrollTop;
								let a = this.$refs.a.offsetTop
								let b = this.$refs.b.offsetTop
								let c = this.$refs.c.offsetTop
								let d = this.$refs.d.offsetTop
								let e = this.$refs.e.offsetTop
												let f = this.$refs.f.offsetTop
								let height = this.$refs.element.offsetHeight
								//  当滚动超过 90 时，实现吸顶效果
								if(scrollTop + 70 >= a) {
									this.TopNav = 1
								}
								if(scrollTop + 70 >= b) {
									this.TopNav = 2
//									this.getData();
								}
								if(scrollTop + 70 >= c) {
									this.TopNav = 3
								}
								if(scrollTop + 70 >= d) {
									this.TopNav = 4
								}
								if(scrollTop + 250 >= e) {
									this.TopNav = 5
								}
								if(scrollTop + 250 >= f) {
									this.TopNav = 6
								}
								if(scrollTop + 80 >= f) {
									this.TopNav = 6
								}
								if(scrollTop > height) {
									this.navBarFixed = true;
								} else {
									this.navBarFixed = false;
								}

			}
		},

		mounted() {
			//banner轮播
			var swiper = new Swiper('.bannerimg', {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				centeredSlides: true,
				autoplay: 3000,
				autoplayDisableOnInteraction: false,
				speed: 800,
				loop: true,
				// initialSlide: 3,
			})
			// 鼠标悬停控制轮播
			var comtainer = document.getElementById('bannerimg');
			comtainer.onmouseenter = function() {
				swiper.stopAutoplay();
			};
			// 鼠标离开 继续轮播
			comtainer.onmouseleave = function() {
				swiper.startAutoplay();
			}
			//		var swiper = new Swiper('.swiper-container', {
			//				slidesPerView: 'auto',
			//				pagination: '.swiper-pagination',
			//			});
			window.addEventListener("scroll", this.watchScroll);
			var th = this
			window.onresize = function() { //监听屏幕的改变
				document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			};
		},
		components: {

		}
	}
</script>
<style>
	@import url('../css/retrospect.css');
	@import url('../css/home.css');
	[v-cloak] {
		display: none !important;
	}

	#home_dataShow {
		box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
	}

	.navBarWrap {
		position: fixed;
		top: 0px;
		z-index: 99999999999999999;
		background-color: #fff;
		width: 100%;
	}

	.focuImg {
		position: relative;
		overflow: hidden;
	}

	.focuImg .li {
		background-color: #668fe7;
		position: absolute;
		border-radius: .3rem;
		color: #fff;
		font-size: .08rem;
		font-weight: 500;
		padding: .06rem .2rem .06rem .2rem;
		transition: all 2s;
		opacity: 0;
	}

	.focuImg .li1.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li2.active {
		transform: translateY(0px);
		opacity: 1;
	}

	.focuImg .li3.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li1 {
		transform: translateX(-100px);
		width: .5rem;
		left: .75rem;
		bottom: .8rem;
	}

	.focuImg .li2 {
		transform: translateY(-100px);
		width: .75rem;
		right: 2.3rem;
		bottom: 1.38rem;
	}

	.focuImg .li3 {
		transform: translateX(100px);
		width: .65rem;
		right: 0.1rem;
		bottom: 1rem;
		z-index: 999999999999999999;
	}

	.swiper-container-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-custom,
	.swiper-pagination-fraction {
		bottom: -40px;
	}

	.swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.swiper-pagination-bullet-active {
		background: #fff;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}
</style>
<style scoped>
	#home_dataShow .dataShow_box {
		width: 1500px;
	}

	.anli .iocBox li .bottomBox {
		position: absolute;
		bottom: 0;
		background-color: transparent !important;
		z-index: 0;
		height: 70px;
		line-height: 70px;
		padding-left: 19px;
	}

	.anli .iocBox li {
		margin-bottom: 39px !important;
	}

	.company_infoContect .guanzhu {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 12px;
	}

	.company_infoContect .wxHao {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-top: 10px;
	}

	.pc {
		padding-top: 67px;
	}

	html,
	body {
		position: relative;
		height: 100%;
	}

	body {
		background: #eee;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}

	.TopNav li.active {
		border-bottom: 1px solid #00C59F;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(20, 20, 20, 1);

	}

	.TopNav {

		display: flex;
	  width: 100%;
	  /* width: 1200px; */
	  box-sizing: border-box;
	  justify-content: center;
		box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
	  margin-bottom: 10px;
		/* padding-left: 450px; */
	 /* float: right; */
	}

	.TopNav li {
	 /* flex: 1;
	    flex-grow: 1; */
	  flex-shrink: 0;
		cursor: pointer;
		/* width: 120px; */
	  padding:0 14px;
		text-align: center;
		margin: 0 30px;
		height: 68px;
		line-height: 68px;
		display: inline-block;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
	}

	.gnld {
		/*padding-top: 83px;*/
		height: 517px;
		width: 1100px;
		margin: 0 auto;
		/*border:1px solid red;*/
	}

	.iocBox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.iocBox li {
		position: relative;
		width: 100px;
		height: 100px;
		margin-right: 150px;
		margin-bottom: 60px;
	}

	.iocBox li:nth-child(5),
	.iocBox li:nth-child(10) {
		margin-right: 0px;
	}

	.iocBox li>img {
		width: 60px;
		height: 60px;
		display: block;
		margin: 0 auto;
	}

	.iocBox li>p {
		height: 18px;
		line-height: 18px;
		font-size: 18px;
		margin-top: 20px;
		text-align: center;
	}

	.yyhy {
		height: 1026px;
		padding: 0px!important;
		padding-top: 150px!important;
		width: 100%;
		display: block;
	}

	.row {
		width: 1126px;
		margin: 0 auto;
		margin-top: 80px;
		display: flex;
	}

	.yyhyitem {
		background-image: url(../../static/img/yyhy_bg.png);
		width: 338px;
		height: 390px;
		margin-right: 56px;
	}

	.yyhyitem img {
		margin: 0 auto;
		padding-top: 75px;
	}

	.yyhyitem .t {
		margin-top: 43px;
		height: 25px;
		text-align: center;
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #3C444F;
		line-height: 22px;
	}

	.yyhyitem .con {
		margin: 0 auto;
		margin-top: 17px;
		width: 241px;
		height: 39px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #3C444F;
		line-height: 22px;
		text-align: center;
	}

	.dzfa {
		height: 765px;
		width: 100%;
		background-image: url(../../static/img/zycpzs_bg.png);
		background-size: 100% 100%;
		display: block;
	}

	.cpdz {
		display: flex;
		margin: 0 auto;
		width: 1056px;
	}

	.cpdzitem {
		width: 186px;
		height: 312px;
		border: 4px dashed #535F6C;
		border-radius: 10px;
		margin-right: 23px;
	}

	.cpdzitem:last-child {
		margin-right: 0px;
	}

	.cpdzitem img {
		padding-top: 40px;
		margin:0 auto
	}

	.cpdzitem .t {
		margin-top: 30px;
		height: 19px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center;
		line-height: 19px;
	}

	.cpdzitem .con {
		width: 154px;
		height: 88px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #B4B7C0;
		margin: 0 auto;
		margin-top: 40px;
	}

	.shyy{
height: 782px;
background: #fff;
display: block;
/*opacity: 0.87;*/
	}
	#shyyflex{
		display: flex;
		margin: 0 auto;
		width: 1084px;
	}
	.shyyitem{
		width: 280px;
		margin-right: 122px;
	}
	.shyyitem:last-child{
		margin-right: 0px;
	}
	.shyyitem img{
		margin: 0 auto;
	}
	.shyyitem .t{
		margin-top: -40px;
height: 18px;
font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #323233;
line-height: 18px;
text-align: center;
	}
	.shyyitem .con{
		margin: 0 auto;
		width: 240px;
margin-top: 22px;
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #808080;
line-height: 34px;
text-align: center;

	}

	.fz42 {
		font-size: .42rem!important;
	}

	.lftext {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: .04rem;
	}

	.dianhua {
		width: .3rem;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		margin: 0 auto;
		margin-top: .05rem;
	}

	.shijian {
		width: .45rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		color: #fff;
		text-align: center;
	}

	.heng {
		width: .27rem;
		height: 1px;
		background-color: #fff;
		margin: .06rem auto;
	}

	.lftext>img {
		margin-right: .03rem;
	}

	.lftext>p {
		font-size: .04rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
	}

	.lf .yuan>img {
		margin: 0 auto;
		display: block;
		width: 74%;
	}

	.lf {
		width: .45rem;
		height: 1.16rem;
		background: linear-gradient(0deg, rgba(0, 184, 148, 1), rgba(0, 197, 159, 1));
		border-radius: .23rem .23rem 0px 0px;
		position: fixed;
		right: 0;
		top: 40%;
		padding: .06rem 0;
		box-sizing: border-box;
	}

	.lianxi {
		height: .92rem;
		display: flex;
		align-items: center;
		background: url('/static/img/img_contactus_bg.png') no-repeat;
		background-size: cover;
		justify-content: center;
	}

	.lianxi p {
		font-size: .11rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(254, 254, 254, 1);
		text-align: center;
	}

	.lianxi a {
		display: flex;
		width: .69rem;
		height: .18rem;
		line-height: .18rem;
		background: rgba(255, 255, 255, 1);
		border-radius: 1px;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(73, 141, 255, 1);
		margin: 0 auto;
		display: flex;
		justify-content: center;
		margin-top: .12rem;
	}

	.gengduo {
		display: block;
		cursor: pointer;
		width: .56rem;
		height: .18rem;
		border: 1px solid rgba(0, 197, 159, 1);
		text-align: center;
		line-height: .18rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(0, 197, 159, 1);
		margin: .2rem auto;
		margin-top: .1rem;
	}

	.gengduo:hover {
		color: #fff;
		background-color: rgba(0, 197, 159, 1);
	}

	.x {
		width: 1200px;
	}

	.mb45 {
		margin-bottom: .45rem;
	}

	.content1 {
		/*padding: .3rem;*/
		position: relative;
	}

	.content1 .mddw {
		position: absolute;
		top: -68px;
		width: 100%;
		height: 68px;
    left:0px;
		z-index: -1;
	}

	.mokuai .gengduo {
		margin-bottom: 0;
		background-color: rgba(0, 197, 159, 1);
		color: #fff;
	}

	.mokuai .gengduo img {
		display: inline-block;
		margin-left: .03rem;
	}

	.bjh {
		background: #F5F6F9;
	}

	.flexY {
		display: flex;
		align-items: center;
	}

	.logoTop .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo>img {
		width: .45rem;
	}

	.logoTop {
		background-color: #fff;
		height: .3rem;
		padding-left: .11rem;
	}

	.logoR p {
		font-family: inpin heiti;
		font-size: .05rem;
	}

	.content1 {
		justify-content: center;
	}

	.imgTextBox {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.imgTextBox p {
		font-size: .08rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		line-height: .16rem;
	}

	.pc .zuhe li {
		width: 1200px;
		height: 400px;
		background: rgba(255, 255, 255, 1);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.pc .zuhe li .zuheBox {
		display: flex;
		align-items: center;
	}

	.fbiaoti {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-top: 23px;
		text-align: center;
		margin-bottom: 100px;
	}

	.JJFA {
		width: 1050px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.topxian {
		width: 74px;
		height: 1px;
		background: #C8C7D8;
		margin-bottom: 15px;
		margin-top: 50px;
	}

	.JJFA .l .pTop {
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(48, 143, 255, 1);
		margin-bottom: 15px;
	}

	.JJFA .l {
		width: 340px;
	}

	.JJFA .l .Plist {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		position: relative;
		padding-left: 20px;
		line-height: 35px;
		margin-bottom: 49px;
	}

	.JJFA .l .Plist:before {
		content: "";
		position: absolute;
		left: 0;
		top: 10px;
		width: 8px;
		height: 16px;
		background: rgba(48, 143, 255, 1);
		border-radius: 4px;
	}

	.pc .zuhe li .zuheBox .rtext {
		margin-left: 144px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav {
		margin-top: 46px;
		display: flex;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div {
		width: 80px;
		margin-right: 36px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div:last-child {
		margin-right: 0;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav img {
		width: 80px;
		height: 80px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav p {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		text-align: center;
		margin-top: 24px;
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(1) {
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(2) {
		margin-top: 18px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox>div>img {
		width: 224px;
		height: 298px;
	}

	.pc .zuhe li .rioc {
		box-sizing: border-box;
		position: absolute;
		right: 20px;
		top: 20px;
		width: 122px;
		height: 42px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 5px 14px 4px rgba(91, 140, 223, 0.09);
		border-radius: 21px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 20px;
		padding-right: 5px;
	}

	.pc .zuhe li .rioc span {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 42px;
	}

	.pc .zuhe li:nth-child(1) .rioc span {
		color: #5AA6FF;
	}

	.pc .zuhe li:nth-child(2) .rioc span {
		color: #5BCA54;
	}

	.pc .zuhe li:nth-child(3) .rioc span {
		color: #948FFF;
	}

	.pc .zuhe li .rioc img {
		width: 36px;
		height: 36px;
		margin: 0;
	}

	.imgTextBox>div:first-child {
		margin-right: .39rem;
		width: 3.3rem;
	}

	.imgTextBox>div:first-child>img {
		width: 100%;
	}

	.yd .anli .iocBox li .bottomBox {
		width: 100%;
		height: 1.3rem;
		border: 0px solid #fff;
		background-color: #fff;
		display: flex;
		align-items: center;
		padding-left: .38rem;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox {
		width: 100%;
		height: .3rem;
		background-color: #fff;
		display: flex;
		align-items: center;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .15rem;
		background-size: 100% 100%;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .15rem;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(20, 20, 20, 1);
	}

	.yd .anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .5rem;
		background: url('/static/img/img_case_name_bg_8.png') center no-repeat;
		background-size: 100% 100%;
		font-size: .28rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .5rem;
		padding: 0 .2rem;
		color: #fff;
	}

	.fuwu li {
		width: 230px;
		text-align: center;
	}

	.fuwu li p {
		margin-top: 0;
	}

	.fuwu li .p1 {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		margin-top: 21px;
		margin-bottom: 33px;
	}

	.fuwu li .p2 {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		line-height: 25px;
	}

	.biaoti {
		font-size: .14rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
		font-size: 36px!important;

/*height: 36px;
font-size: 36px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #323233;*/
	}

	.biaoti1 {
		height: 20px;
		font-size: 20px;
		line-height: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #767676;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/zycpzs.vue